import { Navigate, useParams } from 'react-router-dom';
import AnimatedImage from '../components/AnimatedImage/AnimatedImage';
import projects from '../assets/json/projects.json';

const ProjectFocus = () => {
    const { key } = useParams();
    const project = projects[key];

    if (!project) {
        return <Navigate replace to="/projects" />;
    }

    const { title, longTitle, description } = project;

    return (
        <main className="flex-row large-gap mobile-flip">
            <figure className="project-figure flex-column medium-gap">
                <AnimatedImage alt={title} src={require(`../assets/images/${key}.webp`)} />
                <div className="flex-row flex-wrap sub-gap">
                    {project.skills.map(skill => (
                        <div key={skill} className="project-figure__skill">{skill}</div>
                    ))}
                </div>
            </figure>
            <section className="project-content flex-column medium-gap">
                <h2 className="text-center">{longTitle}</h2>
                <div className="line"></div>
                <p className="text-body">{description}</p>
            </section>
        </main>
    );
};

export default ProjectFocus;